import React, { Fragment } from 'react'
import { Intro, ClickAndReveal, Voiceover } from 'cvs-core'
import image from '../../assets/images/U2-T1-1-6a.svg'
import img1 from '../../assets/images/U2-T1-1-6b.svg'
import img2 from '../../assets/images/U2-T1-1-6c.svg'
import img3 from '../../assets/images/U2-T1-1-6d.svg'
import img4 from '../../assets/images/U2-T1-1-6e.svg'
import img5 from '../../assets/images/U2-T1-1-6f.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Learn-02-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'E-cigarette companies use many misleading advertising practices to increase the market for their product. How much of an informed consumer are you – can you spot the misleading claims? Click on the hotspots to find out!',
}

const data = [
  {
    x: 45,
    y: 50,
    name: 'MISLEADING: NO REAL EVIDENCE',
    modal: {
      title: 'MISLEADING: NO REAL EVIDENCE',
      text: (
        <p>
          When looking at e-cigarette websites, it was found that 95% made
          health-related claims. 64% said vaping could help you quit smoking,
          and 76% claimed that e-cigarettes didn’t produce secondhand smoke.
          There were even doctors featured in 22% of the websites! However, none
          of these claims have been supported by the Federal Drug Administration
          (FDA).
        </p>
      ),
      image: img1,
      imageText: 'MISLEADING: NO REAL EVIDENCE',
    },
  },
  {
    x: 20,
    y: 80,
    name: 'MISLEADING: IMPLICIT TARGETING OF MINORS',
    modal: {
      title: 'MISLEADING: IMPLICIT TARGETING OF MINORS',
      text: (
        <p>
          In 2021, only 11.3% of high school students (1.72 million) and 2.8%
          (320,000) of middle school students reported current e-cigarette use.
          Because of these low numbers, many leading vape companies rely on the
          targeting of minors in their advertising. The FDA is cracking down on
          the use of flavors that appeal to kids, like bubblegum, for their
          e-juices, for example.
        </p>
      ),
      image: img2,
      imageText: 'MISLEADING: IMPLICIT TARGETING OF MINORS',
    },
  },
  {
    x: 60,
    y: 80,
    name: 'MISLEADING: NO SMOKE!',
    modal: {
      title: 'MISLEADING: NO SMOKE!',
      text: (
        <p>
          76% of e-cigarette websites claimed that vaping produced “no
          secondhand smoke,” which is very misleading. While there is no smoke
          associated with vaping, the term itself leads adolescents to think of
          vapor, which consists of water and poses no danger. However, what is
          actually expelled by the user of an e-cigarette is aerosol, which
          contains chemicals, many of which are toxic and can harm your mouth,
          throat, and lungs.
        </p>
      ),
      image: img3,
      imageText: 'MISLEADING: NO SMOKE!',
    },
  },
  {
    x: 79,
    y: 36,
    name: 'MISLEADING: SAFER THAN SMOKING',
    modal: {
      title: 'MISLEADING: SAFER THAN SMOKING',
      text: (
        <p>
          Practices like emphasizing the advantages of using e-cigarettes versus
          cigarettes have been found especially appealing to adolescents. While
          e-cigarettes might be safer than cigarettes, that doesn’t make them
          safe. They still contain nicotine, which is highly addictive, and they
          produce a dangerous aerosol that contains toxic chemicals.
        </p>
      ),
      image: img4,
      imageText: 'MISLEADING: SAFER THAN SMOKING',
    },
  },
  {
    x: 90,
    y: 85,
    name: 'THIS ONE IS TRUE!',
    modal: {
      title: 'THIS ONE IS TRUE!',
      text: (
        <p>
          Because the Federal Drug Administration (FDA) has never supported any
          of these claims, they have been pressured many times to block the type
          of false advertising presented here. In June 2019, a law was passed
          that all e-cigarette advertisements must contain a warning about the
          addictive chemical nicotine. It is also illegal to advertise
          e-cigarettes in traditional formats such as magazines and TV
          commercials.
        </p>
      ),
      image: img5,
      imageText: 'THIS ONE IS TRUE!',
    },
  },
]

export default {
  title: 'Misleading Advertising Claims',
  path: '/prepare/misleading-advertising-claims',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Misleading Advertising Claims"
        lead="How much of an informed consumer are you – can you spot the misleading claims? Click on the hotspots to find out!"
      />
      <ClickAndReveal
        backgroundImage={image}
        backgroundImageText="Background Placeholder"
        data={data}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/MisleadingAdvertisingClaims.js